export enum VariantsActionTypes {
    VARIANTS_ADD = '@@variants/VARIANTS_ADD',
    VARIANTS_ADD_SUCCESS = '@@variants/VARIANTS_ADD_SUCCESS',
    VARIANTS_ADD_ERROR = '@@variants/VARIANTS_ADD_ERROR',
}
